import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_EM_PROVIDER_LIST = "GET_EM_PROVIDER_LIST";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Analytics/GetBellCurveReportParameterProviderList`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_EM_PROVIDER_LIST, service, mock);

